const observer = import.meta.client
  ? new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer!.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    )
  : null;

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('reveal', {
    getSSRProps: () => ({ class: 'reveal' }),
    created: (el) => el.classList.add('reveal'), // client matches SSR
    // add class on CSR
    beforeMount: (el) => {
      if (!el.classList.contains('reveal')) el.classList.add('reveal');
    },
    mounted: (el) => observer?.observe(el),
    unmounted: (el) => observer?.unobserve(el),
  });
});
